import {
  isQuotingToolAvailable,
  hasProcessPermission,
} from 'modules/common/permissions';

import { initOpDefDetailsPage } from './detailsPage/data/sagas';
import OpDefDetailsPage from './detailsPage/entry';
import { initOpDefListPage } from './listPage/data/sagas';
import OpDefListPage from './listPage/entry';

export default [
  {
    component: OpDefListPage,
    exact: true,
    name: 'opDefListPage',
    path: '/processes/operations',
    permissions: [isQuotingToolAvailable, hasProcessPermission],
    saga: initOpDefListPage,
  },
  {
    component: OpDefDetailsPage,
    exact: true,
    name: 'opDefDetailsPage',
    path: '/processes/operations/:opDefId',
    permissions: [isQuotingToolAvailable, hasProcessPermission],
    saga: initOpDefDetailsPage,
  },
];
